// extracted by mini-css-extract-plugin
export var button = "_og-0";